// extracted by mini-css-extract-plugin
module.exports = {"expanded":"TrustStrip_expanded__Njk7g","plainCard":"TrustStrip_plainCard__zhKKM","iconBadge":"TrustStrip_iconBadge__tqYgO"};